/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { constants } from './models/autoupdate/constants';
import { UpdateJobResult } from './models/rollouts/constants';
import { i18n } from './plugins/i18n';

export const filters = {

  beautifyResourceFileType: (value: string) =>
    ({
      [constants.RESOURCE_FILE_TYPE_FULL_SOFTWARE_UPDATE]:
        'Full Software Update',
      [constants.RESOURCE_FILE_TYPE_INCREMENTAL_SOFTWARE_UPDATE]:
        'Incr. Software Update',
      [constants.RESOURCE_FILE_TYPE_DSL_UPDATE]: 'DSL Update',
      [constants.RESOURCE_FILE_TYPE_CONTAINER]: 'Container',
      [constants.RESOURCE_FILE_TYPE_CONTAINER_CONFIGURATION]:
        'Container-Configuration',
      [constants.RESOURCE_FILE_TYPE_LICENCE]: 'License',
      [constants.RESOURCE_FILE_TYPE_BINARY_CONFIGURATION]:
        'Binary-Configuration',
      [constants.RESOURCE_FILE_TYPE_ASCII_CONFIG]: 'ASCII-Configuration',
      [constants.RESOURCE_FILE_TYPE_STORED_ASCII_CONFIG]:
        'Stored ASCII-Configuration',
      [constants.RESOURCE_FILE_TYPE_ASCII_CONFIG_ICS]:
        'ASCII-Configuration ICS',
      [constants.RESOURCE_FILE_TYPE_OEM_BRANDING]: 'OEM Branding',
      [constants.RESOURCE_FILE_TYPE_CELLULAR_MODEM_FIRMWARE]: 'Cellular Modem Firmware'
    })[value] || '',

  updateJobDeviceProgressReason: (value: string) =>
    ({
      [UpdateJobResult.UPDATED_SUCCESS]: i18n.t('main.resultSuccess'),
      [UpdateJobResult.UPDATED_IGNORED]: i18n.t('main.resultIgnored'),
      [UpdateJobResult.UPDATED_LIST_PRECOND_UNMET]: i18n.t(
        'main.resultPreconditionUnmet'
      ),
      [UpdateJobResult.UPDATED_ERROR]: i18n.t('main.resultError'),
      [UpdateJobResult.UPDATED_ERROR_UNIMPLEMENTED]: i18n.t(
        'main.resultError'
      ),
      [UpdateJobResult.UPDATED_ERROR_BUSY]: i18n.t('main.resultErrorBusy'),
      [UpdateJobResult.UPDATED_ERROR_DISK_SPACE]: i18n.t(
        'main.resultErrorDiskSpace'
      ),
      [UpdateJobResult.UPDATED_ERROR_FILE_CORRUPT]: i18n.t(
        'main.resultErrorFileCorrupt'
      ),
      [UpdateJobResult.UPDATED_ERROR_BASE_VERSION_MISSING]: i18n.t(
        'main.resultErrorBaseVersionMissing'
      ),
      [UpdateJobResult.UPDATED_ERROR_DECRYPTION]: i18n.t(
        'main.resultErrorDecryption'
      ),
      [UpdateJobResult.UPDATED_ERROR_MANIFEST_MISMATCH]: i18n.t(
        'main.resultErrorManifestMismatch'
      ),
      [UpdateJobResult.UPDATED_ERROR_KERNEL_FAILED]: i18n.t(
        'main.resultErrorKernelFailed'
      ),
      [UpdateJobResult.UPDATED_ERROR_FILESYSTEM]: i18n.t(
        'main.resultErrorFileSystem'
      ),
      [UpdateJobResult.UPDATED_ERROR_DOWNLOAD_PACKAGE]: i18n.t(
        'main.resultErrorDownloadPackage'
      ),
      [UpdateJobResult.UPDATED_ERROR_DOWNLOAD_LIST]: i18n.t(
        'main.resultErrorDownloadList'
      ),
      [UpdateJobResult.UPDATED_ERROR_SERVER_UNREACHABLE]: i18n.t(
        'main.resultErrorServerUnreachable'
      )
    })[value] || i18n.t('main.resultError'),

  truncate: (text: string, length: number, clamp?: string) => {
    clamp = clamp || '...';
    const node = document.createElement('div');
    node.innerHTML = text;
    const content = node.textContent;
    return content && content.length > length
      ? content?.slice(0, length) + clamp
      : content;
  },
  getGraphqlUrlHTTP: () => {
    let url = import.meta.env.VITE_API_GRAPHQL_HTTPS_URL;
    if (!url) {
      url = import.meta.env.VITE_API_GRAPHQL_HTTP_URL;
    }
    return fixGraphqlUrl(url, false);
  },
  getGraphqlUrlWS: () => {
    let url = import.meta.env.VITE_API_GRAPHQL_WSS_URL;
    if (!url) {
      url = import.meta.env.VITE_API_GRAPHQL_WS_URL;
    }
    return fixGraphqlUrl(url, true);
  },
  assetUrl: (value: string) => `${import.meta.env.BASE_URL || '/'}${value}`
} as const;


function fixGraphqlUrl(value: string, websocket: boolean) {
  const locationProtocol = window.location.protocol.split(':')[0];
  const isTLS = locationProtocol === 'https';
  let prefix = isTLS ? 'wss' : 'ws';
  if (!websocket) {
    prefix = isTLS ? 'https' : 'http';
  }

  if (value.indexOf('://') !== -1) {
    return value;
  } else if (value.startsWith('/')) {
    return `${prefix}://${window.location.hostname}${value}`;
  } else {
    return `${prefix}://${value}`;
  }
}
